export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const toggleModal = (payload) => ({ type: TOGGLE_MODAL, payload });
export const closeModal = () => ({ type: CLOSE_MODAL });
